_ = require('lodash')

module.exports = (
  $scope,
  $state,
  $log,
  $window,
  $q,
  $rootScope,
  $interval,
  Login,
  user,
  stickyMessage,
  settings
) ->

  $scope.user = user
  $scope.stickyMessage = stickyMessage
  $scope.ENVIRONMENT = settings.ENVIRONMENT
  $scope._UDA_ID = null
  $scope.chrome = $window.chrome

  $scope.findUDAIfInstalled = (callback) ->
    if (typeof $scope.chrome == 'undefined' || !$scope.chrome || typeof $scope.chrome.runtime == 'undefined')
      callback(false)
      return
    promises = ($q((resolve) ->
      $scope.chrome.runtime.sendMessage uda_id, {type: 'isHarmoniaEnabled'}, {},
        (response) ->
          if (response && response.success)
            resolve(response.extensionID)
          else
            resolve(false)
    ) for uda_id in settings.UDA_IDS)

    $q.all(promises).then (ids) ->
      # filter out false values (eg that extension not being installed)
      ids = _.compact(ids)
      if ids.length > 1
        $rootScope.error = "You have multiple active versions of UDA. This can cause unexpected behaviour."
      callback(ids[0] || false)

  $scope.installedUDAID = () ->
    if $scope._UDA_ID == null
      $scope.findUDAIfInstalled((isInstalled) ->
        $scope._UDA_ID = isInstalled
      )

    return $scope._UDA_ID

  $scope.installedUDAID()

  # When D3 is running in an iframe
  # The frame element is to check we're not running in an iframe
  if $window.inIframe
    previousSize = 0
    $scope.inIframe = true

    sendResizeMessage = ->
      size = $window.document.querySelector('html').scrollHeight
      if previousSize != size
        previousSize = size
        $window.parent.postMessage('resize::' + size, '*')
    $window.setInterval(sendResizeMessage, 300)
